<template>
  <div class="background" >
      <div id="content" @scroll="handleScroll"> 
      
     <div id="lang"> 
      <a href="#" @click.prevent="navigateTo('usageTermsEn')">English</a>
      <a> | </a>
     <a href="#" @click.prevent="navigateTo('usageTermsCn')">中文</a>

     </div>
      

     <h1>服务条款</h1>
     <h2 >本条款包含的内容</h2>
     <li>1.条款声明及修订</li>
     <li>2.我们提供的服务内容</li>
     <li>3.用户所需要遵守的使用规则</li>
     <li>4.用户隐私</li>
     
     <h2  >1.条款声明及修订</h2>
     <li>本条款本次修订时间为UTC+08:00 2020-12-20,前一次修订时间为UTC+08:00 2020-10-20.</li>
     <li>最近修订涉及内容:用户隐私.</li>
     <li>本条款用于说明本手机应用'优优加速器'(以下简称本应用)服务内容/用户需遵守的规则/用户隐私策略相关内容,即阐明服务方与被服务方的权利与义务.本条款解释权归本应用持有者.</li>
     
     <li>使用本应用前须详阅本条款,若不认同条款内容可与本应用客服人员反馈或停止使用本应用.当用户开始使用本应用时,我们将视为用户已同意条款所有内容.</li>
     <li>本应用对当用户行为造成的侵害不承担任何责任,包括所有刑事和民事责任.当第三方发现本应用用户疑似存在违反当地法律的行为,可以联系本应用运营人员以配合核查处理.</li>
     
     <li>本条款会不定时更新完善,若更新内容与之前相关内容有冲突,请重新详阅最新条款并决定是否继续使用.</li>
     
     
     <h2  >2.我们提供的服务内容</h2>
     
     <li>本应用所提供的服务是暂时性数字网络通信服务,用户设备在进行网络通信时,对用户网络通信数据进行加密转发,并隐匿用户直接访问记录,以增强网络通信安全,进而保护用户隐私.</li>
     
     <li>本应用须提供安全可用的网络代理服务器节点,不可抗力因素除外.</li>
     <li>我们致力于给用户提供满意的服务,当用户对某些服务不满意时可以向运营人员提交反馈,也可以在付款7个自然日内提交退款申请.</li>
     <li>我们用收到用户的反馈时,须会在相应的时限内为用户解决或回应.</li>
     
     <h2 >3.用户所需要遵守的使用规则</h2>
     
     <li>用户在使用本应用时,应该遵守用户使用时所在地区的法律.</li>
     <li>用户不得以任何形式通过本应用对其它组织或个人发起可能造成侵害的行为.</li>
     <li>用户不得以任何形式发布和传播色情内容(包括但不限于未成年人情色内容)/暴力内容/歧视内容(包括但不限于宗教歧视/性别歧视/地域歧视/种族歧视等)等违背道德伦理相关内容.</li>
     
     <li>用户不得对本应用进行逆编码/破解/影响其正常运行的操作.</li>
     <li>当用户违反以上使用规则时,本应用运营人员有权在不通知用户的前提下,直接停用其账号,若账号涉及付款亦不予以退款.</li>
     
     <h2  >4.用户隐私</h2>
     
     <li>本应用在加密和转发网络数据的过程中,不会拆分/解密/缓存用户网络数据包,只网络请求数据包行进二次加密及转发.</li>
     <li>本应用不会读取或缓存任何与本应用功能无关的用户数据,不会将任何与本应用相关的用户数据转发或缓存至任何第三方.</li>
          </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: 'clearUserData',
      lastScrollTop: 0, // 记录上一次的滚动位置
    }
  },
  methods: {
      navigateTo(routeName) {
        this.$router.push({ name: routeName });
      }
  },
  handleScroll(event) {
      const currentScrollTop = event.target.scrollTop;
      if (currentScrollTop > this.lastScrollTop && currentScrollTop > 0) {
        // 向下滚动
        // console.log('向下滚动');
      } else {
        // 向上滚动
        // console.log('向上滚动');
      }
      this.lastScrollTop = currentScrollTop;
    }
}
</script>

<style scoped>
#content { 
 background-color: #eeeeee;
   float:none;
    margin: 20px 10%;
    padding-left:20px ;
    padding-right:20px ;
    padding-bottom:40px ;
    text-align:left;
    overflow-y: scroll;
    height: 80%; /* 根据需要设置高度 */
    } 
#footer { 
width: 100%;
    height:30px; 
    text-align:center;
    color:white;
    background: #333; } 
#lang { color:black; text-align:right;height:30; padding:5px;
    padding-top:10px ; } 

.background {
  position: fixed;
  width: 100%;
  height: 100%;
  background-image: url('../assets/weee.jpg');
  opacity: 0.8;
  background-size: cover;
  background-position: center;
  flex: 1;
}
h1 {
  text-align: left;
  margin-left: 15px;
  margin-right: 15px;
  margin-top: 8px;
  font-size: 20px;
  color: #4f4e4e;
}
h2 {
  text-align: left;
  margin-left: 15px;
  margin-right: 15px;
  margin-top: 8px;
  font-size: 16px;
  color: #4f4e4e;
}
li {
  text-align: left;
  margin-left: 15px;
  margin-right: 15px;
  margin-top: 8px;
  font-size: 13px;
  color: #4f4e4e;
}
</style>
